"use client";

import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

import cn from "classnames";
import s from "./RichText.module.scss";
import { preprocessContent, unwrapCustomParagraphs } from "../helpers/content";
import { htmlOverrides } from "../richText/richTextOverrides";
import { useRichTextElements } from "@/components/pages/blog/ai-article/richText/RichTextElementsContext";

export type RichTextProps = {
  content?: string;
  className?: string;
};

/**
 * Shared.RichText
 * Supports markdown, gfm, raw html + custom components
 *
 * ¯\_(ツ)_/¯
 * NOTE:
 *      This component always wraps content into <p> (paragraph)
 *      If you need to render without <p> use component <HTML> ->
 *      it supports only raw html, and wraps content into <span>
 *
 * @relation StrapiSharedRichText
 * @param content
 * @param className
 * @constructor
 */
export const RichText = ({ content, className }: RichTextProps) => {
  const customElements = useRichTextElements();

  if (!content) return null;

  const customTagNames = Object.keys(customElements);

  return (
    <Markdown
      remarkRehypeOptions={{ allowDangerousHtml: true }}
      className={cn(className, s.content)}
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[
        rehypeRaw,
        // remove p wrapper on custom components
        [unwrapCustomParagraphs, customTagNames],
      ]}
      //@ts-ignore
      components={{
        ...customElements,
        ...htmlOverrides,
      }}
    >
      {preprocessContent(content)}
    </Markdown>
  );
};
